import { ActiveEntityType } from "@common/build/activeEntityType";
import { SmartTileTypes } from "@common/build/types";
import { BuilderComponentProps } from "@common/components/BuilderInterface";
import BuilderSmartTile from "@common/components/BuilderSmartGrid/BuilderSmartTile";
import HookWrapper from "@common/components/HookWrapper";
import { DynamicDataInfo, DynamicDataSectionProvider } from "@common/Contexts/DynamicDataTypeContext";

const SmartTileWrapper = (props: BuilderComponentProps) => {
    const smartTileNode = props.node as any;

    let dynamicDataValue: DynamicDataInfo | null = null;

    switch (smartTileNode.smartTileType) {
        case SmartTileTypes.PRODUCT:
            dynamicDataValue = {
                dynamicDataScope: ActiveEntityType.PRODUCT,
                dynamicDataObject: props?.storeData
            };
            break;
        case SmartTileTypes.ACTION:
        case SmartTileTypes.CATEGORY:
        case SmartTileTypes.FOLDER:
            dynamicDataValue = {
                dynamicDataScope: ActiveEntityType.SMART_GRID,
                dynamicDataObject: props?.storeData
            };
            break;
    }

    if (dynamicDataValue) {
        return (
            <DynamicDataSectionProvider value={dynamicDataValue}>
                <HookWrapper component={BuilderSmartTile} {...props} />
            </DynamicDataSectionProvider>
        );
    }

    return <HookWrapper component={BuilderSmartTile} {...props} />;
};

export default SmartTileWrapper;
